import { FC, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ModalAction from 'src/components/Items/Actions';
import SimpleInput from 'src/components/Items/input/SimpleInput';
import { useActions } from 'src/hooks/useActions';
import { Driver, IDriver } from 'src/models/IDriver';

interface IProps {}

const AdditionalDriverForm: FC<IProps> = () => {

  const [driver, setDriver] = useState(new Driver());
  const { id } = useParams();
  const navigate = useNavigate();
  const { addDriver } = useActions();

  const handleInput = (name: string) => (value: string | number) => {
    if (name === 'email') {
      setDriver({ ...driver, 'email': value.toString().toLowerCase() });
    } else {
      setDriver({ ...driver, [name]: value });
    }
  };

  const handleClose = () => {
    navigate('/');
  };
  const submit = () => {
    addDriver(driver, id as string);
    navigate('/success/general');
  };
  const _renderInput = (
    name: keyof IDriver,
    title: string = name,
    placeholder: string,
    length: number = 60
  ) => (
    <SimpleInput
      data={driver[name]!}
      setData={handleInput(name)}
      title={title}
      length={length}
      placeholder={placeholder}
    />
  );
  return (
    <>
      <div className='col-2'>
        {_renderInput('first_name', 'First name', 'Enter their first name')}
        {_renderInput('email', 'Drivers Email', 'Enter their email')}
      </div>
      <p style={{ fontSize: '16px', color: '#7d879c', marginTop: '20px' }}>
        You can Invite several drivers, one at the time from the email.
      </p>
      <ModalAction
        type='driver'
        handleClose={handleClose}
        handleSubmit={submit}
        action='Invite'
      />
    </>
  );
};
export default AdditionalDriverForm;
